import { render, staticRenderFns } from "./editBoDefaultDomain.vue?vue&type=template&id=7ff1fa42&lang=pug"
import script from "./editBoDefaultDomain.vue?vue&type=script&lang=js"
export * from "./editBoDefaultDomain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports